import { Chunk } from './Chunk';

export class ChunkHandler {
  constructor (renderer) {
    this.chunks = [];
    this.renderer = renderer;
    this.visible = false;
  }

  addChunk (x, y, w, h, tw, th) {
    this.chunks.push(new Chunk(x, y, w, h, tw, th, this.renderer));
  }

  createTile (x, y, wX, wY, requestQueue, zoom) {
    let chunk = this.determineChunk(wX, wY);

    if (chunk) {
      chunk.createTile(x, y, requestQueue, zoom);
    }
  }

  determineChunk (x, y) {
    return this.chunks.find((chunk) => chunk.rect.isPointInside(x, y));
  }

  update (isVisible, zoom, cameraRect) {
    this.visible = isVisible;
    if (this.visible) {
      for (let chunk of this.chunks) {
        chunk.update(zoom);

        if (cameraRect.isRectangleOverlap(chunk.viewRect)) {
          chunk.visible = true;
        } else {
          chunk.visible = false;
          chunk.unloadChunk();
        }
      }
    } else {
      this.unload();
    }
  }

  unload () {
    for (let chunk of this.chunks) {
      chunk.unloadChunk();
    }
  }

  draw () {
    if (this.visible) {
      this.chunks.forEach((chunk) => chunk.draw());
    }
  }
}
